import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const certId = params.get("certification_id");
  return (
    <div className="max-w-xl mx-auto px-6 py-16 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-12 h-12 text-muted2 mx-auto" />
      <h1 className="font-display text-3xl text-ink-900 mt-6">Paiement annulé</h1>
      <p className="text-muted2 mt-2 text-sm">
        Aucun montant n'a été débité. Vous pouvez reprendre l'achat à tout moment.
      </p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to={certId ? "/categories" : "/categories"}
          className="px-6 py-3 rounded-full bg-gold-500 text-ink-900 font-medium hover:bg-gold-400 inline-flex items-center justify-center gap-2"
          data-testid="back-to-categories"
        >
          <ArrowLeft className="w-4 h-4" /> Explorer les certifications
        </Link>
        <Link
          to="/dashboard"
          className="px-6 py-3 rounded-full border border-gold-500/50 text-ink-900 hover:bg-gold-500/10"
        >
          Tableau de bord
        </Link>
      </div>
    </div>
  );
}
